import httpClient from "./httpClient";

export function getInstituteProfile() {
  return httpClient.get("/institute/profile").then((res) => res.data.data);
}

export function updateInstituteProfile(payload) {
  return httpClient.put("/institute/profile", payload).then((res) => res.data.data);
}

export function updateInstituteLogo(file) {
  const formData = new FormData();
  formData.append("file", file);
  return httpClient
    .post("/institute/profile/logo", formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((res) => res.data.data);
}
